var __await = (this && this.__await) || function (v) { return this instanceof __await ? (this.v = v, this) : new __await(v); }
var __asyncValues = (this && this.__asyncValues) || function (o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i);
    function verb(n) { i[n] = o[n] && function (v) { return new Promise(function (resolve, reject) { v = o[n](v), settle(resolve, reject, v.done, v.value); }); }; }
    function settle(resolve, reject, d, v) { Promise.resolve(v).then(function(v) { resolve({ value: v, done: d }); }, reject); }
};
var __asyncGenerator = (this && this.__asyncGenerator) || function (thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = Object.create((typeof AsyncIterator === "function" ? AsyncIterator : Object).prototype), verb("next"), verb("throw"), verb("return", awaitReturn), i[Symbol.asyncIterator] = function () { return this; }, i;
    function awaitReturn(f) { return function (v) { return Promise.resolve(v).then(f, reject); }; }
    function verb(n, f) { if (g[n]) { i[n] = function (v) { return new Promise(function (a, b) { q.push([n, v, a, b]) > 1 || resume(n, v); }); }; if (f) i[n] = f(i[n]); } }
    function resume(n, v) { try { step(g[n](v)); } catch (e) { settle(q[0][3], e); } }
    function step(r) { r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r); }
    function fulfill(value) { resume("next", value); }
    function reject(value) { resume("throw", value); }
    function settle(f, v) { if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]); }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
define(["require", "exports", "asyncsse", "underscore"], function (require, exports, asyncsse_1, underscore_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.BaseChatV1BetaClient = void 0;
    underscore_1 = __importDefault(underscore_1);
    ;
    class BaseChatV1BetaClient {
        constructor(options) {
            this.headers = { "Content-Type": "application/json" };
            this.url = options.url;
            this.channelOptions = options.channelOptions;
        }
        requestHeadersAsync() {
            return new Promise((res, rej) => {
                const requestHeadersAsync = this.channelOptions.application.options.ajaxOptions
                    && this.channelOptions.application.options.ajaxOptions.requestHeadersAsync;
                if (requestHeadersAsync) {
                    requestHeadersAsync(this.url, (error, headerData) => {
                        if (error) {
                            res(this.headers);
                        }
                        res(underscore_1.default.extend({}, this.headers, headerData));
                    });
                }
                else {
                    res(this.headers);
                }
            });
        }
        performStreamRequest(request, requestOptions) {
            return __asyncGenerator(this, arguments, function* performStreamRequest_1() {
                var _a, e_1, _b, _c;
                const headers = yield __await(this.requestHeadersAsync());
                try {
                    // https://github.com/sanand0/asyncsse?tab=readme-ov-file#example-openai-chat-completions
                    for (var _d = true, _e = __asyncValues((0, asyncsse_1.asyncSSE)(this.url + this.path, {
                        method: "POST",
                        headers: headers,
                        body: JSON.stringify(request),
                        credentials: "include",
                        signal: requestOptions === null || requestOptions === void 0 ? void 0 : requestOptions.signal,
                    })), _f; _f = yield __await(_e.next()), _a = _f.done, !_a; _d = true) {
                        _c = _f.value;
                        _d = false;
                        const event = _c;
                        if (event.data) {
                            try {
                                const tokenEvent = JSON.parse(event.data);
                                yield yield __await(tokenEvent);
                            }
                            catch (e) {
                                // Ignore the non-JSON data chunk
                            }
                        }
                        else if (event.error) {
                            throw new Error(event.error);
                        }
                    }
                }
                catch (e_1_1) { e_1 = { error: e_1_1 }; }
                finally {
                    try {
                        if (!_d && !_a && (_b = _e.return)) yield __await(_b.call(_e));
                    }
                    finally { if (e_1) throw e_1.error; }
                }
            });
        }
        removeEmptyParams(options) {
            const validOptions = Object.keys(options).reduce((acc, key) => {
                const value = options[key];
                if (value !== null && value !== undefined && value !== '') {
                    acc[key] = value;
                }
                return acc;
            }, {});
            return validOptions;
        }
    }
    exports.BaseChatV1BetaClient = BaseChatV1BetaClient;
});
